import { createFileRoute } from "@tanstack/react-router";
import SEOAudit from "@/pages/SEOAudit";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/seo-audit/")({
  head: () => routeHead("/uk/seo-audit/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SEOAudit />
  );
}
